import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Select from 'react-select';
import InputMask from 'react-input-mask';

import { Modal } from 'react-bootstrap';

class ScheduleGradeStaffVacationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      staff: null,
      schedule_grade_group_staff_id: null,
      loaded: 0,
      schedule_grade_group_staff_periods: [],
      group_list: [],
      period_list: [],
      id: '',
    };
    //Handlers
    this.closeModal = this.closeModal.bind(this);
    this.edit = this.edit.bind(this);
    this.updateData = this.updateData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      if(typeof newProps.id !== 'undefined' && this.state.loaded === 0) {
        this.setState({
          modal: true,
          schedule_grade_group_staff_id: newProps.id,
          date_start: newProps.date_start,
          date_finish: newProps.date_finish,
          staff_id: newProps.staff_id,
          staff: newProps.staff,
          loaded: 1,
        });
      }
    } else {
      this.setState({
        modal: false,
        loaded: 0,
      });
    }
  }

  // Adiciono uma aeronave na escala
  edit(event) {
    event.preventDefault();
    var confirm = window.confirm('Tem certeza que gostaria alocar este colaborador para férias?');
    var self = this;
    if (confirm) {
      self.props.handleAlert('', '', 'open');
      var datasave = {
        staff: this.state.staff,
        staff_id: this.state.staff_id,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        schedule_grade_group_staff_id: this.state.schedule_grade_group_staff_id,
      };
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/editar/ferias', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          self.updateData(responseJson);
          }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  modalOff (event) {
    this.setState({ modal: false});
  }


  updateData() {
    this.setState({
      modal: false,
      schedule_grade_group_staff_id: null,
      date_start: null,
      date_finish: null,
      staff: null,
    });

    this.props.updateData();
  }

  closeModal() {
    this.setState({
      modal: false,
      schedule_grade_group_staff_id: null,
      date_start: null,
      date_finish: null,
      staff: null,
    });

    this.props.closeModal();
  }
  

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Modal show={self.state.modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
            <Modal.Header>
            <h4 className="pull-left">Editar período de férias do colaborador - {self.state.staff}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.closeModal()}}><i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
            </Modal.Header>
            <Modal.Body>
            <form onSubmit={this.edit}>
                <RequestApi ref={'request_api'} />
                <div className="row">
                <div className="col-md-6">
                    <label>Data inicial:</label>
                    <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
                </div>
                <div className="col-md-6">
                    <label>Data final:</label>
                    <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
                </div>
                </div>
                <div className="row">
                <div className="col-md-12">
                    <button type="submit" className="btn btn-success btn-block"><i className="fa fa-fw fa-sign-in"></i>Salvar</button>
                </div>
                </div>
            </form>
            </Modal.Body>
            <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.closeModal()}}><i className="fa fa-fw fa-close"></i></button>
            </Modal.Footer>
        </Modal>

      </div>
    );
  }
}

export default ScheduleGradeStaffVacationModal;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/ScheduleGradeStaffVacationModal.js